import type { LicenseData } from "../hooks/useLicenseStore"

// Keep the JSON shape stable while removing answers to skipped questions.
export const applySharingRules = (data: LicenseData): LicenseData => {
  const onwardSharing = typeof data.onwardSharing === "string"
    ? data.onwardSharing.trim().toLowerCase()
    : data.onwardSharing

  return onwardSharing === "no" || onwardSharing === false
    ? { ...data, shareAlike: "no", modifications: "no" }
    : data
}
